export default __webpack_public_path__ + "static/media/pinkHorn.beb05bf4.svg";